const mainFooterUsefulLinks = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/products" },
];

export default mainFooterUsefulLinks;
